<template>
    <div class="h-full">
        <Head :title="__(title)"/>
        <board-view-menu :project="project" view="discussion"/>
        <div class="flex flex-col task__dashboard px-4 py-4 gap-4 h-[calc(100%-52px)] overflow-hidden overflow-y-auto">
            <div class="flex gap-5 flex-col lg:flex-row w-full">
                <div class="w-full bg-white rounded-lg shadow-lg p-10">
                    <section class="mt-8">
                        <div>
                            <div class="flex">
                                <icon class="w-4 h-4 mr-3 mt-1" name="comments"/>
                                <div class="flex-1 border-b pb-2">
                                    <span class="text-sm font-medium">{{ __('Project Discussion') }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="pl-8 pt-4">
                            <div class="mt-4">
                                <div v-for="(comment, comment_i) in project.project_comments">
                                    <div class="chat-container" v-if="$page.props.auth.user.id !== comment.user.id">
                                        <div class="chat-avatar mr-4">{{ getInitials(comment.user.name) }}</div>
                                        <div class="chat-bubble">
                                            <div class="chat-meta">
                                                <div class="chat-name"> {{ comment.user.name }}</div>
                                                <div class="chat-time">{{
                                                        moment(comment.created_at).format('MMMM D, YYYY [at] h:mm a')
                                                    }}
                                                </div>
                                            </div>
                                            <div class="chat-content" v-html="comment.body">
                                            </div>
                                            <!--                        <div class="chat-footer">No file attachment</div>-->
                                        </div>
                                    </div>

                                    <div class="chat-container chat-reply" v-if="$page.props.auth.user.id === comment.user.id">
                                        <div class="chat-bubble">
                                            <div class="chat-meta">
                                                <div class="chat-name">{{ comment.user.name }}</div>
                                                <div class="chat-time">{{
                                                        moment(comment.created_at).format('MMMM D, YYYY [at] h:mm a')
                                                    }}
                                                </div>
                                            </div>
                                            <div class="chat-content" v-html="comment.body"></div>
                                            <!--                        <div class="chat-footer">No file attachment</div>-->
                                        </div>
                                        <div class="chat-avatar ml-4">{{ getInitials(comment.user.name) }}</div>
                                    </div>
                                </div>
                            </div>


                            <div class="mt-4">
                                <div>
                                    <div v-if="!showCommentBox"
                                         class="mt-1 mb-4 cursor-pointer rounded-md border border-gray-300 hover:shadow"
                                    >
                                        <p @click="showCommentBox = true" class="px-3 py-2 text-sm ">
                                            {{ __('Write a comment...') }}
                                        </p>
                                    </div>

                                    <form v-if="showCommentBox" class="mt-1 mb-4 rounded-md border border-gray-300"
                                          enctype="multipart/form-data"
                                    >
                                        <!--                                                <textarea v-model="new_comment.details" class="autosize p-3 comment-textarea block max-h-40 w-full resize-none rounded-md border-0 text-sm focus:ring-0" placeholder="Write a comment..." style="overflow: hidden; overflow-wrap: break-word;background:transparent">{{ new_comment.details || '' }}</textarea>-->
                                        <quill-editor ref="editDescription" @ready="onEditorReady"
                                                      class="task__description"
                                                      v-model:content="new_comment.details" :options="editorOptions"
                                                      contentType="html" theme="snow"
                                        />

                                        <div class="flex items-center px-3 pt-2 pb-3">
                                            <div class="flex items-center">
                                                <button
                                                    @click="saveNewComment({body: new_comment.details, project_id: project.id, user_id: $page.props.auth.user.id}, project.project_comments)"
                                                    type="button"
                                                    class="inline-flex items-center rounded border border-gray-300 bg-indigo-600 text-white px-2.5 py-1.5 text-xs font-medium shadow-sm hover:bg-gray-50 hover:text-dark focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                                >
                                                    {{ __('Save') }}
                                                </button>
                                                <button @click="showCommentBox = false" type="button"
                                                        class="inline-flex items-center rounded border border-transparent hover:border-gray-300 bg-white px-2.5 py-1.5 text-xs font-medium hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-0 ltr:ml-1 rtl:mr-1"
                                                >{{ __('Cancel') }}
                                                </button>
                                            </div>

                                            <div class="ml-auto hidden flex">
                                                <label class="cursor-pointer">
                                                    <input
                                                        accept="image/png, image/jpeg, image/gif,.doc,.docx,.pdf,.txt,.zip,.rar,.7zip,.mp4,video/*,.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,application/vnd.ms-powerpoint,.webp,.tiff,.pptx,.mp3,.ai,.eps,.svg,.fig,.sketch,.jam"
                                                        class="hidden" type="file"
                                                        @change="uploadAttachment($event, true)"
                                                    >
                                                    <icon class="w-4 h-4" name="attachment"/>
                                                </label>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import Icon from '@/Shared/Icon'
import BoardViewMenu from '@/Shared/BoardViewMenu'
import FloatingNewTaskBtn from '@/Shared/FloatingNewTaskBtn'
import axios from 'axios'
import { QuillEditor } from '@vueup/vue-quill'
import '@vuepic/vue-datepicker/dist/main.css'
import 'moment-duration-format'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import 'filepond/dist/filepond.min.css'
import moment from 'moment'

export default {
    components: {
        FloatingNewTaskBtn,
        Head,
        Icon,
        Link,
        BoardViewMenu,
        QuillEditor
    },
    layout: Layout,
    props: {
        task: {
            comments: Array,
        },
        comment: Array,
        title: String,
        auth: Object,
        project: Object,
        per_list: Object,
        per_assignee: Object,
        per_label: Object,
        due_data: {
            required: true,
        },
    },
    data() {
        return {
            showCommentBox: false,
            new_comment: {},
            quill: null,
            documentUploads: [
                {
                    selectedFile: null,
                    name: '',
                    uploaded: false,
                    preview: null,
                    fileItem: null,
                },
            ],
            uploadedDocuments: [],
            form: this.$inertia.form({
                errors: {},
                processing: false,
                editDescription: true,
            }),
            task: {},
            currentDate: new Date().toISOString().split('T')[0], // to set the max date
            editorOptions: {
                modules: {
                    toolbar: {
                        container: [
                            {'header': [1, 2, 3, 4, 5, 6, false]},
                            'bold', 'italic', 'underline', {'list': 'bullet'}, {'list': 'ordered'},
                            'align', 'clean',
                            'blockquote', 'code-block',
                            // 'image'
                        ],
                        // handlers: { 'image': this.imageButtonClickHandler }
                    },
                    // imageDrop: true,
                },
            },
        }
    },
    computed: {},
    created() {
        this.moment = moment
    },
    methods: {
        getInitials(name) {
            // Split the name into words
            const words = name.split(' ');
            // Get the first letter of each word and concatenate them
            let initials = '';
            words.forEach(word => {
                if (word) {
                    initials += word.charAt(0).toUpperCase();
                }
            });
            return initials;
        },
        usersNames(users) {
            return users.map(user => user.name).join(', ')
        },

        onEditorReady(editor){editor.focus();},
        saveNewComment(commentObject, currentComments) {
            this.new_comment.details = ''
            axios.post(this.route('projects.new'), commentObject).then((response) => {
                if (response.data) {
                    currentComments.push(response.data)
                    this.showCommentBox = false
                  //  this.sendNotification('send.mail.comment', response.data.id)
                }
            }).catch((error) => {
                console.log(error)
            })
        },
        deleteComment(id, index, comments){
            axios.post(this.route('comment.delete', id)).catch((error) => {
                console.log(error)
            })
            comments.splice(index, 1);
        },
        saveComment(id, commentObject){
            axios.post(this.route('comment.update', id), { details: commentObject.details }).catch((error) => {
                console.log(error)
            })
        },
    }
}
</script>
